// extracted by mini-css-extract-plugin
var _1 = "DocFlowSelectModalTableRow-moduleDocFlowSelectModalTableRow__HSxXr TableComponent-modulerow__xPAo4";
var _2 = "DocFlowSelectModalTableRow-modulearchivedIconContainer__R2ruT EntityArchivedIcon-moduleentityArchivedIconContainer__u1fL2 IconNG-moduleiconContainer__SxWZ0";
export { _1 as "DocFlowSelectModalTableRow", _2 as "archivedIconContainer" }
